import React, {Component} from 'react';
import GroupModalSelectForm from './GroupModalSelectForm'

class GroupLinkParentUpdate extends Component {
  state = {
    visible: false
  };
  showModal = () => {
    this.setState({visible: true});
  };
  handleCancel = () => {
    this.setState({visible: false});
  };
  handleUpdate = () => {
    const {group, onUpdate} = this.props
    const form = this.form;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const {GroupID} = values
      const updateGroup = {
        ...group,
        ParentID: GroupID
      }
      onUpdate(updateGroup)
      form.resetFields();
      this.setState({visible: false});
    });
  };
  saveFormRef = (form) => {
    this.form = form;
  };

  render() {
    const {disabled, group, groups, treeGroups} = this.props
    const selectedGroup = {
      ID: group.ParentID
    }
    const title = `Thay đổi địa bàn gốc cho địa bàn [${group.Name}]`
    return (<span>
      {
        disabled
          ? <span>Đổi địa bàn lớn</span>
          : <a onClick={this.showModal}>Đổi địa bàn lớn</a>
      }
      <GroupModalSelectForm title={title} group={selectedGroup} groups={groups} treeGroups={treeGroups} ref={this.saveFormRef} visible={this.state.visible} onCancel={this.handleCancel} onSubmit={this.handleUpdate}/>
    </span>);
  }
}

export default GroupLinkParentUpdate;



// WEBPACK FOOTER //
// ./src/components/GroupLinkParentUpdate.js